import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {FormDefinitionFormModel} from "../../../api/entity/formDefinitionForm.model";
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";

@Injectable()
export class FormDefinitionFormRepository extends AbstractRepositoryV2<FormDefinitionFormModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('FormDefinitionForm', serviceElementsFactory, injector);
    }
}
